module.exports = __webpack_public_path__ + "img/checklist.110a86b1.png";